/* PVC: Grazly-only free-shipping progress bar for the Zipify OCU Smart Cart.
   Shows how close the cart is to 2 Grazly-vendor items (free shipping).
   Front-end display only; the actual free-shipping entitlement is handled by the
   store's existing discount. Injected site-wide via layout/theme.liquid. */
(function () {
  var THRESHOLD_QTY = 2;                      // Grazly items required for free shipping
  var VENDOR = 'Grazly';                      // must match the product Vendor field exactly
  var COLLECTION_URL = '/collections/grazly'; // where "add more" sends shoppers
  var PVC_GREEN = '#559206';                  // brand green, makes the truck pop
  var BAR_ID = 'pvc-grazly-ship-bar';
  // Offer sunset: matches the Appstle "Happy 250th" shipping discount end date.
  // After this moment the bar stops rendering (and removes itself if present).
  // To extend the offer: update this date AND the discount end date in Appstle.
  var OFFER_ENDS_MS = Date.parse('2026-07-06T08:00:00Z');
  var lastTotal = null;

  function barHTML(qty) {
    var pct = Math.min(100, Math.round(qty * 100 / THRESHOLD_QTY));
    var unlocked = qty >= THRESHOLD_QTY;
    // 3-state messaging (cost-avoidance system, quantity threshold):
    //   A: no Grazly in cart   B: one in, one to go   D: unlocked
    var msg;
    if (unlocked) {
      msg = 'Shipping: <strong style="color:' + PVC_GREEN + ';">$0</strong> on your whole order.';
    } else {
      var line;
      if (qty === 0) {
        line = 'Shipping costs money. <strong>Any 2 Grazly snacks</strong> make it <strong>$0</strong>.';
      } else {
        line = '<strong>1 more Grazly snack</strong> takes shipping to <strong>$0</strong>';
      }
      msg = '<a href="' + COLLECTION_URL + '" style="color:#111;text-decoration:none;">' + line + '</a>';
    }
    // explicit CTA link below the track (states A-C only): carries the click affordance
    var cta = unlocked
      ? ''
      : '<div style="margin-top:7px;text-align:center;">'
        + '<a href="' + COLLECTION_URL + '" style="display:inline-block;font-size:13px;font-weight:700;color:' + PVC_GREEN + ';text-decoration:underline;text-underline-offset:3px;">Shop Grazly snacks &rarr;</a></div>';
    var fill = PVC_GREEN;
    var truck = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="' + PVC_GREEN + '" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px;">'
      + '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>'
      + '<circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>';
    return '<div style="font-size:14px;line-height:1.3;text-align:center;margin-bottom:7px;color:#111;">' + truck + msg + '</div>'
      + '<div style="height:10px;border-radius:10px;background:rgba(255,255,255,.9);overflow:hidden;">'
      + '<div style="display:block;height:100%;width:' + pct + '%;border-radius:10px;background:' + fill + ';transition:width .35s ease;"></div></div>'
      + cta;
  }

  function render() {
    if (Date.now() >= OFFER_ENDS_MS) {
      var expired = document.getElementById(BAR_ID);
      if (expired && expired.parentElement) expired.parentElement.removeChild(expired);
      return;
    }
    var root = document.querySelector('.ocu-cart-drawer');
    if (!root) return;
    var items = root.querySelector('.ocu-cart-line-items');
    var header = root.querySelector('.ocu-cart-header');
    if (!items && !header) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if ((cart.items[i].vendor || '') === VENDOR) qty += cart.items[i].quantity;
        }
        var bar = root.querySelector('#' + BAR_ID);
        var isNew = false;
        if (!bar) {
          bar = document.createElement('div');
          bar.id = BAR_ID;
          bar.style.cssText = 'padding:12px 16px;border-bottom:1px solid rgba(0,0,0,.08);background:#ecf2e5;';
          isNew = true;
        }
        if (lastTotal !== qty || isNew) {
          bar.innerHTML = barHTML(qty);
          lastTotal = qty;
        }
        // keep it pinned directly above the line items (or just under the header)
        if (items && items.parentElement) {
          if (bar.parentElement !== items.parentElement || bar.nextElementSibling !== items) {
            items.parentElement.insertBefore(bar, items);
          }
        } else if (!bar.parentElement && header) {
          header.insertAdjacentElement('afterend', bar);
        }
      })
      .catch(function () {});
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 150); }

  // Re-render whenever the OCU cart opens or its contents change (qty edits, etc.),
  // ignoring mutations inside our own bar to avoid feedback loops.
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var tgt = muts[i].target;
      if (tgt && tgt.closest && tgt.closest('#' + BAR_ID)) continue;
      if (document.querySelector('.ocu-cart-drawer')) { schedule(); return; }
    }
  });
  obs.observe(document.documentElement, { subtree: true, childList: true });

  schedule();
})();
